// extracted by mini-css-extract-plugin
export default {"errorPage":"systemerror_errorPage__QJ6DC","header":"systemerror_header__pEqwN","content":"systemerror_content__zBNsQ"};